import { reactive } from "vue";
import axios from "axios";

export const makeRequest = async (method, resource, params = undefined, data = undefined, config = undefined) => {
    let request = {
        async: true,
        crossDomain: true,
        url: process.env.VUE_APP_ROOT_API + resource,
        method: method,
        paramsSerializer: params => {
            const searchParams = new URLSearchParams();
            for (const key in params) {
                if (Array.isArray(params[key])) {
                    for (const value of params[key]) {
                        searchParams.append(key, value);
                    }
                } else {
                    searchParams.append(key, params[key]);
                }
            }
            return searchParams.toString();
        }
    };
    if (params) request = { ...request, params: params };
    if (data) request = { ...request, data: data };
    if (config) request = { ...request, ...config };

    try {
        const response = await axios(request);
        return response;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export default reactive({
    get: (resource, params, data, config) => makeRequest("get", resource, params, data, config),
    post: (resource, params, data, config) => makeRequest("post", resource, params, data, config),
    put: (resource, params, data, config) => makeRequest("put", resource, params, data, config),
    delete: (resource, params, data, config) => makeRequest("delete", resource, params, data, config)
});
